var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.065V3.01626C0 1.35042 1.34315 0 3 0H17C18.6569 0 20 1.35042 20 3.01626V12.065C20 13.7309 18.6569 15.0813 17 15.0813H12.7515L10.1463 17.3732C8.5298 18.7953 6 17.6411 6 15.4816V15.0813H3C1.34315 15.0813 0 13.7309 0 12.065ZM7.76118 14.1276C7.42328 13.4981 6.76132 13.0704 6 13.0704H3C2.44772 13.0704 2 12.6203 2 12.065V3.01626C2 2.46098 2.44772 2.01084 3 2.01084H17C17.5523 2.01084 18 2.46098 18 3.01626V12.065C18 12.6203 17.5523 13.0704 17 13.0704H12.7515C12.267 13.0704 11.799 13.2472 11.4345 13.568L8.82925 15.8599C8.50596 16.1443 8 15.9135 8 15.4816V15.0813C8 15.0194 7.99722 14.9581 7.99177 14.8976C7.96792 14.6329 7.89306 14.383 7.77716 14.158C7.77192 14.1478 7.76659 14.1377 7.76118 14.1276Z",
    fill: "#B1ADA2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.a49ba95cf7e9eb44fc201f62d7e9f0d7.svg";
export { ForwardRef as ReactComponent };